import React from 'react';
import { MODE_TABS } from './constants';

const ModeTabs = ({ activeMode, onChange }) => (
  <div className="player-roles-tabs">
    {MODE_TABS.map((tab) => {
      const active = activeMode === tab.key;
      return (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`player-roles-tab ${active ? 'active' : ''}`}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default ModeTabs;
